var _rect, _path, _path2, _circle, _circle2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNaverSolution1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 77,
    viewBox: "0 0 77 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14.248,
    y: 26.5532,
    width: 53.6451,
    height: 34.5218,
    rx: 5,
    fill: "#08794B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7715 15.2817H50.5011C53.2625 15.2817 55.5011 17.5203 55.5011 20.2817V21.6973H32.2917C30.7582 21.6973 29.3095 20.9936 28.3615 19.7883L28.1351 19.5003C27.6136 18.8373 26.9328 18.3169 26.1561 17.9877L19.7715 15.2817Z",
    fill: "#513DC3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.7846 17.0846C29.8347 15.9424 28.426 15.2817 26.9404 15.2817H15.5762C12.8147 15.2817 10.5762 17.5203 10.5762 20.2817V51.0393C10.5762 53.8007 12.8147 56.0393 15.5762 56.0393H58.0104C60.7719 56.0393 63.0104 53.8007 63.0104 51.0393V26.6972C63.0104 23.9357 60.7719 21.6972 58.0104 21.6972H36.9657C35.4801 21.6972 34.0714 21.0365 33.1214 19.8943L30.7846 17.0846Z",
    fill: "url(#paint0_linear_2137_19391)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 58.4507,
    cy: 26.3702,
    r: 1.4605,
    fill: "#513DC3"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 54.1949,
    cy: 26.3702,
    r: 1.4605,
    fill: "#513DC3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9512 43.8143L24.0643 36.7008L31.1778 43.8143L41.0702 33.9219M41.0702 33.9219H35.204M41.0702 33.9219V39.4854",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2137_19391",
    x1: 9.21774,
    y1: 38.4547,
    x2: 66.4168,
    y2: 37.113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#27E599"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70FFC6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNaverSolution1);
export default __webpack_public_path__ + "static/media/naverSolution1.e17034ec18bdefbb6b0e5657de701aba.svg";
export { ForwardRef as ReactComponent };